/*=====================================
    確認視窗

    Author: Gray
    createtime: 2018 / 01 / 11
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from "actions/creators";
import { DialogStyle } from 'stylecomponents';
import classNames from "classnames";

/*--------------------------
    Main Component
--------------------------*/
class ConfirmDialog extends Component {

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {

        super(props);

        this.state = {
            isLoading: false,
            errorMsg: '',
        };

        this.isLoading = false;

        this.closeDialog = this.closeDialog.bind(this);
        this.confirm = this.confirm.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    // ------------------------------
    // componentDidMount
    // ------------------------------
    componentDidMount() {}

    // ------------------------------
    // componentWillReceiveProps
    // ------------------------------
    componentWillReceiveProps(nextProps) {}

    // ------------------------------
    // componentDidUpdate
    // ------------------------------
    componentDidUpdate(prevProps, prevState) {}

    // ------------------------------
    // 關閉
    // ------------------------------
    closeDialog() {

        this.props.webActions.closeConfirmDialog();
    }

    // ------------------------------
    // 確認
    // ------------------------------
    confirm() {

        if(this.state.isLoading || this.isLoading) {
            return;
        }

        this.isLoading = true;

        if(!this.props.confirmDialog.isPromise) {
            this.props.confirmDialog.confirmCallback && this.props.confirmDialog.confirmCallback();
            this.closeDialog();
            this.isLoading = false;
        } else {
            this.setState({
                isLoading: true,
            }, () => {

                this.props.confirmDialog.confirmPromise().then((result) => {

                    this.setState({
                        isLoading: false,
                    });
                    this.closeDialog();
                    this.isLoading = false;

                }, (errorMsg) => {
                    this.setState({
                        isLoading: false,
                        errorMsg: errorMsg,
                    });
                    this.isLoading = false;
                });
            })
        }
    }

    // ------------------------------
    // 取消 
    // ------------------------------
    cancel() {

        this.props.confirmDialog.cancelCallback && this.props.confirmDialog.cancelCallback();
        this.closeDialog();

        if(this.state.isLoading) {
            this.setState({
                isLoading: false,
            });
        }
    }

    // ------------------------------
    // render
    // ------------------------------
    render() {

        const {
            title,
            description,
            confirmName,
        } = this.props.confirmDialog;

        return (

            <DialogStyle.Content
                className="confirm-modal"
                // style props
                maxWidth="320px"
                padding="0"
                borderRadius="3px"
                backgroundColor="#fff"
                // dialog props
                visible={true}
                animation="zoom"
                maskAnimation="fade"
                animationDuration={250}
                closable={false}
                maskClosable={true}
                keyboard={false}
                onClose={this.cancel}
            >
                <div className="confirm-modal-content">
                    <h3 className="title">{title}</h3>
                    <p className="description">{description}</p>
                    <div className="button-group">
                        <div
                            className={classNames("button blue submit", {
                               'disable': this.state.isLoading
                            })}
                            onClick={this.confirm}
                        >
                            {this.state.isLoading ?
                                <i className="zmdi zmdi-spinner animate-spinner"></i>
                                :
                                null
                            }
                            {confirmName ?
                                confirmName
                                :
                                '確定'
                            }
                        </div>
                        <div className="button" onClick={this.cancel}>
                            取消
                        </div>
                    </div>

                    {this.state.errorMsg ? 
                        <div className="error-msg">
                            {this.state.errorMsg}
                        </div>
                        :
                        null
                    }
                </div>                
            </DialogStyle.Content>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        confirmDialog: state.web.confirmDialog,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(ConfirmDialog);



// WEBPACK FOOTER //
// ./src/components/dialog/ConfirmDialog.jsx